module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/can-vux-used-in-weapp-10.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/can-vux-used-in-weapp.md
// module id = 587
// module chunks = 463